// A task tracked again from a saved copy (a resume) carries the others' tracking status from when it was saved.
// My own tracked user stays as it is, its time ticks locally; the others take the status the API answered.
// In place: the copy a later resume starts from (lastTrackedTask) shares these tracked users, and keeps getting my
// new time slots only while it does
export function refreshOthersTrackingStatus(ttbus, apiTtbus, myUserId) {
  const online = new Map(apiTtbus.map(ttbu => [ttbu.id, ttbu.trackingOnline]));
  (ttbus || []).forEach((ttbu) => {
    if (ttbu.userId !== myUserId && online.has(ttbu.id)) {
      ttbu.trackingOnline = online.get(ttbu.id);
    }
  });
}
